/**
 * LMTM Recommend
 *
 *  1. 件数を必ず埋める
 *     セクションは「手動指定 → 同じクリエイター」までを描いて DOM に出す。
 *     足りないときだけ Shopify のおすすめ商品を取りに行って足し、
 *     それでも足りないぶんを、あらかじめ hidden で置いてある埋め草から出す。
 *     重複は商品URLで判定する。
 *
 *  2. カルーセルの左右送り
 *     送り幅はカード1枚ぶん（= 表示列幅）。
 *
 * 取得した HTML の中身は Liquid 側の分岐次第で手動指定ぶんを含むこともあるが、
 * URL で重複を落とすのでどちらでも同じ結果になる。
 */
(function () {
  'use strict';

  /* ============ 件数を埋める ============ */

  function cardsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.lmtm-pcard'));
  }

  function visibleCards(root) {
    return cardsOf(root).filter(function (card) {
      return !card.hasAttribute('hidden');
    });
  }

  function padCards(root) {
    return cardsOf(root).filter(function (card) {
      return card.classList.contains('lmtm-pcard--pad');
    });
  }

  function keyOf(card) {
    // ?variant= などが付くことはないが、念のため パス部分だけで比べる
    var href = card.getAttribute('href') || '';
    return href.split('?')[0];
  }

  function fillFromPads(root, target) {
    var pads = padCards(root);
    pads.forEach(function (pad) {
      if (visibleCards(root).length < target) {
        pad.removeAttribute('hidden');
      } else {
        pad.remove();
      }
    });
  }

  function appendAuto(root, target, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var incoming = Array.prototype.slice.call(doc.querySelectorAll('.lmtm-pcard')).filter(function (card) {
      return !card.classList.contains('lmtm-pcard--pad');
    });
    if (incoming.length === 0) return;

    var track = root.querySelector('[data-lmtm-carousel-track]');
    if (!track) return;

    var seen = {};
    cardsOf(root).forEach(function (card) {
      seen[keyOf(card)] = true;
    });

    var firstPad = padCards(root)[0] || null;

    incoming.forEach(function (card) {
      if (visibleCards(root).length >= target) return;
      var key = keyOf(card);
      if (!key || seen[key]) return;
      seen[key] = true;
      card.removeAttribute('hidden');
      track.insertBefore(document.importNode(card, true), firstPad);
    });
  }

  function fill(root) {
    var target = parseInt(root.getAttribute('data-target'), 10) || 4;

    if (visibleCards(root).length >= target) {
      padCards(root).forEach(function (pad) {
        pad.remove();
      });
      syncArrows(root);
      return;
    }

    if (root.getAttribute('data-need-auto') !== 'true' || !root.getAttribute('data-url')) {
      fillFromPads(root, target);
      syncArrows(root);
      return;
    }

    fetch(root.getAttribute('data-url'))
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        appendAuto(root, target, text);
      })
      .catch(function () {
        /* 取れなくても埋め草で埋めるので握りつぶす */
      })
      .then(function () {
        fillFromPads(root, target);
        syncArrows(root);
      });
  }

  /* ============ カルーセル ============ */

  function step(track) {
    var card = track.querySelector('.lmtm-pcard:not([hidden])');
    return card ? card.offsetWidth : track.clientWidth / 4;
  }

  function syncArrows(root) {
    var frame = root.querySelector('[data-lmtm-carousel]') || root;
    var track = frame.querySelector('[data-lmtm-carousel-track]');
    var prev = frame.querySelector('[data-lmtm-carousel-prev]');
    var next = frame.querySelector('[data-lmtm-carousel-next]');
    if (!track || !prev || !next) return;

    var overflow = track.scrollWidth - track.clientWidth;
    if (overflow <= 1) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= overflow - 1;
  }

  document.addEventListener('click', function (ev) {
    var button =
      ev.target.closest && ev.target.closest('[data-lmtm-carousel-prev], [data-lmtm-carousel-next]');
    if (!button) return;
    var frame = button.closest('[data-lmtm-carousel]');
    var track = frame && frame.querySelector('[data-lmtm-carousel-track]');
    if (!track) return;
    var dir = button.hasAttribute('data-lmtm-carousel-prev') ? -1 : 1;
    track.scrollLeft += dir * step(track);
  });

  function start() {
    document.querySelectorAll('[data-lmtm-recommend]').forEach(function (root) {
      var track = root.querySelector('[data-lmtm-carousel-track]');
      if (track) {
        track.addEventListener('scroll', function () {
          syncArrows(root);
        });
      }
      window.addEventListener('resize', function () {
        syncArrows(root);
      });
      fill(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
